import { render, staticRenderFns } from "./teachingInfo.vue?vue&type=template&id=1366dff8&scoped=true&"
import script from "./teachingInfo.vue?vue&type=script&lang=js&"
export * from "./teachingInfo.vue?vue&type=script&lang=js&"
import style0 from "./teachingInfo.vue?vue&type=style&index=0&id=1366dff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1366dff8",
  null
  
)

export default component.exports